export default __webpack_public_path__ + "static/media/spikes_7.c759e817.svg";